import styled from '@emotion/styled';

export const Pre = styled.div`
  white-space: pre;
`;
